/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './settings.css';

function SideBar({ handleSelect, listItemTexts }) {
  const [selectedItem, setSelectedItem] = useState(1);

  const handleClick = (value) => {
    setSelectedItem(value);
    handleSelect(value);
  };

  return (
    <div className="flex-shrink-0" style={{ borderRight: '1px solid #e0e1e6', minWidth: 210 }}>
      <nav className="flex flex-col gap-1 p-3">
        {listItemTexts.map((text, index) => {
          const idx = index + 1;
          const active = selectedItem === idx;
          return (
            <button
              key={index}
              type="button"
              onClick={() => handleClick(idx)}
              className={`text-left px-3 py-2 rounded-[8px] text-sm bg-transparent border-0 cursor-pointer transition ${active ? 'bg-[#eef1f7] text-brand-700 font-semibold' : 'text-ink-500 font-medium hover:bg-surface-1 hover:text-ink-900'}`}
            >
              {text}
            </button>
          );
        })}
      </nav>
    </div>
  );
}

SideBar.propTypes = {
  handleSelect: PropTypes.func.isRequired,
  listItemTexts: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SideBar;
